import { render, staticRenderFns } from "./chartAutonomia.vue?vue&type=template&id=4172cbe8&"
import script from "./chartAutonomia.vue?vue&type=script&lang=js&"
export * from "./chartAutonomia.vue?vue&type=script&lang=js&"
import style0 from "./chartAutonomia.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports